module.exports = __webpack_public_path__ + "img/attack_firedragon.9baf91f8.png";